import { useState } from "react";
import styles from "./list.module.css";
import dayjs from "dayjs";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, TableFooter, Tooltip } from "@mui/material";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import TablePaginationComponent from "../../../components/TablePagination";
import { ArrowForwardOutlined, Close, PrintOutlined } from "@mui/icons-material";
import { List, Map, Search } from "react-feather";
import { DateRangePicker } from "rsuite";
import { useReactToPrint, ReactToPrint, PrintContextConsumer } from "react-to-print";
import { ComponentToPrintList } from "./ComponentToPrintList";
import { ComponentToPrint } from "./ComponentToPrint";
import { useRef } from "react";
import { useCallback } from "react";
import { authData } from "../../../components/GetAuth";

const ButtonArea = ({ data }) => {
    const componentRef = useRef();
    const Export = ({ onExport }) => (<Button onClick={(e) => onExport(e.target.value)} className="TableAddBU" style={{ width: "auto" }}>Export To CSV</Button>);

    const convertArrayOfObjectsToCSV = (array) => {
        let result = "";

        const columnDelimiter = ",";
        const lineDelimiter = "\n";
        const keys = ["booking_id", "post_code", "driver_name", "pickup_address", "contact_no", "pickup_date", "assigned_date"];

        keys.forEach((key) => {
            if (key === "booking_id") {
                result += "Booking Id";
            } else if (key === "post_code") {
                result += "Post Code";
            } else if (key === "driver_name") {
                result += "Driver Name";
            } else if (key === "pickup_address") {
                result += "Pickup Address";
            } else if (key === "contact_no") {
                result += "Contact No";
            } else if (key === "pickup_date") {
                result += "Pickup Date";
            } else if (key === "assigned_date") {
                result += "Assigned Date";
            } else {
                result += key;
            }
            result += columnDelimiter;
        });
        result += lineDelimiter;

        array.forEach((item) => {
            let ctr = 0;
            keys.forEach((key) => {
                if (ctr > 0) result += columnDelimiter;
                result += item[key];
                ctr++;
            });
            result += lineDelimiter;
        });

        return result;
    };

    const downloadCSV = useCallback(() => {
        let newArray = data.map((row) => {
            return {
                booking_id: row?.booking_id,
                post_code: row?.post_code,
                driver_name: row?.driver?.name,
                pickup_address: row?.pickup_details?.address.replace(/,/g, ""),
                contact_no: row?.pickup_details?.phone,
                pickup_date: dayjs(row.pickup_date).format("DD/MM/YYYY"),
                assigned_date: dayjs(row?.driver?.assigned_date).format("DD/MM/YYYY"),
            };
        });

        const link = document.createElement("a");
        let csv = convertArrayOfObjectsToCSV(newArray);
        if (csv == null) return;

        const filename = "driver-list.csv";

        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
        }
        link.setAttribute("href", encodeURI(csv));
        link.setAttribute("download", filename);
        link.click();
    }, [data]);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (<>
        <Export onExport={() => downloadCSV()} />
        <Button onClick={handlePrint} className="TableAddBU" style={{ width: "auto" }}>Print Bookings</Button>
        <div style={{ display: "none" }}>
            <ComponentToPrintList ref={componentRef} data={data} />
        </div>
    </>);
};

const ListView = ({ filteredData, filterVars, setSelectedId, setFormOpen, setFilterVars, setViewType, page, setPage, rowsPerPage, setRowsPerPage, totalCount }) => {
    const componentRef = useRef();
    const auth = authData();

    const paginationChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const paginationChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    return (<>
        <div className="TableFilterHead">
            <div className="DataTableSearch WithFilter">
                <Search className="SearchIcon" />
                <TextField type="text" placeholder="Search" value={filterVars?.searchKey} onChange={(e) => setFilterVars((prev) => { return { ...prev, searchKey: e.target.value }; })} />
                {filterVars?.searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setFilterVars((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>

            <div className="TableFilterBUSec">
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec`}>
                        <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Serach by date" value={filterVars?.date} showOneCalendar onChange={(e) => setFilterVars((prev) => { return { ...prev, date: e }; })} />
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex' }}>
                <Button className={`${styles.SwitchBtn} ${styles.SwitchBtnActive}`}><List /></Button>
                <Button className={`${styles.SwitchBtn}`} onClick={(e) => setViewType('map')}><Map /></Button>
            </div>
        </div>
        <div className={`${styles.FilerButton} TableFilterBUSec`}>
            <ButtonArea style={{ float: "right" }} data={filteredData}></ButtonArea>
        </div>
        <div className="CusTable">
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <StyledMainTableCell>Booking Id</StyledMainTableCell>
                            <StyledMainTableCell>Post Code</StyledMainTableCell>
                            <StyledMainTableCell>Driver Name</StyledMainTableCell>
                            <StyledMainTableCell>Pickup Address</StyledMainTableCell>
                            <StyledMainTableCell>Contact No</StyledMainTableCell>
                            <StyledMainTableCell>Pickup Date</StyledMainTableCell>
                            <StyledMainTableCell>Assigned Date</StyledMainTableCell>
                            <StyledMainTableCell>Action</StyledMainTableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {filteredData.map((item) => {
                            return (<StyledMainTableRow key={item?.id}>
                                <TableCell component="th" scope="row">{item?.booking_id}</TableCell>
                                <TableCell component="th" scope="row">{item?.post_code}</TableCell>
                                <TableCell component="th" scope="row">{item?.driver?.name}</TableCell>
                                <TableCell component="th" scope="row">{item?.pickup_details?.address}</TableCell>
                                <TableCell component="th" scope="row">{item?.pickup_details?.phone}</TableCell>
                                <TableCell component="th" scope="row">{dayjs(item?.pickup_date).format("DD/MM/YYYY")}</TableCell>
                                <TableCell component="th" scope="row">{dayjs(item?.driver?.assigned_date).format("DD/MM/YYYY")}</TableCell>
                                <TableCell component="th" scope="row">
                                    <Tooltip title="Print">
                                        <div style={{ display: "none" }}>
                                            <ComponentToPrint ref={(el) => (componentRef[item?.id] = el)} bookingData={filteredData} driver_id={item?.driver?.id} />
                                        </div>
                                        <ReactToPrint content={() => componentRef[item?.id]}>
                                            <PrintContextConsumer>
                                                {({ handlePrint }) => (<Button className="ActionBU" onClick={handlePrint}><PrintOutlined /></Button>)}
                                            </PrintContextConsumer>
                                        </ReactToPrint>
                                    </Tooltip>
                                    {(auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:assign-driver') > -1) && <Tooltip title="Re-Assign or Unassign">
                                        <Button className="ActionBU" onClick={(e) => { setFormOpen(true); setSelectedId(item?.id); }}><ArrowForwardOutlined /></Button>
                                    </Tooltip>}
                                </TableCell>
                            </StyledMainTableRow>);
                        })}

                        {filteredData.length === 0 && (<TableRow>
                            <TableCell colSpan={10} align="center">No data found</TableCell>
                        </TableRow>)}
                    </TableBody>

                    {filteredData?.length > 0 && (<TableFooter>
                        <TableRow>
                            <TablePaginationComponent
                                count={totalCount}
                                colSpan={6}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                handleChangePage={paginationChangePage}
                                handleChangeRowsPerPage={
                                    paginationChangeRowsPerPage
                                }
                            />
                        </TableRow>
                    </TableFooter>)}
                </Table>
            </TableContainer>
        </div>
    </>);
};

export default ListView;